const model = {
    startStopLoading: false,
    startStopError: null,
    message: '',
    status: null,
};

export default model;